var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'background-image': 'url(' + require(`./assets/images/login/${_vm.businessBack}`) + ')'}),attrs:{"id":"app"}},[_c('v-app',[_c('LoginMaster',{attrs:{"msg":"Welcome to Your Vue.js App"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }